<template>
  <div class="box">
    <header>
      <p class="logo"></p>
      <p class="logoname">PT. LAYANAN ASIA BERSATU</p>
    </header>
    <div class="home" id="home">
      <img @click="goGP()" src="../assets/Googleplay.png" alt="">
    </div>
  
    <div class="features" id="why">
      <h2 class="title">The core values we instill are:</h2>
      <div class="cards">
        <div class="card">
          <img class="ball" src="../assets/why1.png" alt="" />
          <h5>Quick job realization</h5>
        </div>
        <div class="card">
          <img class="ball" src="../assets/why2.png" alt="" />
          <h5>Fighting spirit</h5>
        </div>
        <div class="card">
          <img class="ball" src="../assets/why3.png" alt="" />
          <h5>Sense of responsibility</h5>
        </div>
        <div class="card">
          <img class="ball" src="../assets/why4.png" alt="" />
          <h5>Result-oriented</h5>
        </div>
      </div>
    </div>
    <div class="product">
      <div class="content">
        <div class="title">Our Products</div>
        <p>Sector Progress View is a tool used to display the progress or completion of a task, process, or metric. It is typically presented in a circular or sector-shaped form, divided into multiple sectors, with each sector representing a different progress state. Users can understand the progress of the task based on the color, fill level, or other visual cues of the sectors.</p>
      </div>
    </div>
    <footer>
      Address: Rukan Sedayu Square Blok H No 36, Jl. Kamal Outer Ringroad
    </footer>
  </div>
</template>

<script>
import privacy from "@/components/privacy";
export default {
  name: "App",
  components: {
    privacy,
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      showPrivasi: false,
      show: false,
    };
  },
  mounted() {
    if (this.$route.query.partner == 1) {
      this.$nextTick(()=>{
        setTimeout(()=>{
          document.getElementById("partner").scrollIntoView();
        },100)
      })
    }
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  methods: {
    goGP(){
      window.open("https://play.google.com/store/apps/details?id=com.vldh.sectorprogressview")
    },
    choiceMenu(index) {
      this.menuIndex = index;
      setTimeout(() => {
        this.showMenu = false;
      }, 100);
      switch (index) {
        case 0:
          document.getElementById("home").scrollIntoView();
          break;
        case 1:
          document.getElementById("step").scrollIntoView();
          break;
        case 2:
          document.getElementById("product").scrollIntoView();
          break;
        case 3:
          document.getElementById("user").scrollIntoView();
          break;
        case 4:
          document.getElementById("about").scrollIntoView();
          break;
        case 5:
          document.getElementById("privacy").scrollIntoView();
          break;
        case 6:
          document.getElementById("footer").scrollIntoView();
          break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu;
    },
    goPrivacy(){
      this.$router.push({
        path:"/privacy"
      })
    }
  },
};
</script>
<style lang="less">
@import url("@/style/m_index.less") only screen and (max-width: 750px);
@import url("@/style/pc_index.less") only screen and (min-width: 750px);
</style>
<style scoped>
.privasi {
  margin-top: 234px;
  padding: 0;
}
</style>
